module.exports = __webpack_public_path__ + "static/media/user-male.e0699fa2.svg";